module.exports = __webpack_public_path__ + "assets/img/order_question_tip.1ee2ad79.png";